import { StepsProps } from 'antd';
import * as Styled from './styles';

type TStepsProps = StepsProps;

export const Steps = (props: TStepsProps) => {
  return <Styled.AntSteps {...props}>{props.children}</Styled.AntSteps>;
};
